import Modal from "../../components/Modal";
import "./Partner.css";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import { partnerActions } from "../../actions/partner.action";
import TableHeader from "../../components/Table/TableHeader";
import PaginationComponent from "../../components/Table/PartnerPagination";
import SearchBar from "../../components/forms/Searchbar";
import InvitationModal from "../../components/Modal";

export default function Partner() {
  const [selectedItemsPerPage, setSelectedItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedFilter, setSelectedFilter] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const ITEMS_PER_PAGE = selectedItemsPerPage;
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();
  const headers = [
    { name: "Logo", field: "companyLogo", sortable: false },
    { name: "Company", field: "companyName", sortable: true },
    { name: "Expertise", field: "expertiseDescription", sortable: true },
    { name: "Website", field: "webSite", sortable: true },
    { name: "Email", field: "email", sortable: true },
    { name: "PhoneNumber", field: "phoneNumber", sortable: true },
  ];

  const UserType = {
    GHG: "GHG account and marketing",
    VAP: "Verification Assurance Provider",
    CMAP: "Carbon Market Access Provider",
    OTHER: "Other",
    ALL: "All",
  };
  const partners = useSelector((state) => state.partner.data);
  useEffect(() => {
    dispatch(partnerActions.getPartnerList());
  }, [dispatch]);

  const handleFilterChange = (value) => {
    console.log("Value:: ", value);
    setSelectedFilter(value);
  };

  const updatedPartners = partners;
  const totalItems = updatedPartners.length;
  const dataToShow = useMemo(() => {
    let partnerData = updatedPartners;

    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      partnerData.sort((a, b) => {
        const fieldX = a[sorting.field] || "";
        const fieldY = b[sorting.field] || "";
        return reversed * fieldX.localeCompare(fieldY);
      });
    }
    if (selectedFilter && selectedFilter.toLowerCase() !== "all") {
      partnerData = updatedPartners.filter(
        (partner) => partner.userType === selectedFilter
      );
    } else {
      partnerData = partners;
    }
    if (search) {
      partnerData = partnerData.filter(
        (partner) =>
          partner.companyName?.toLowerCase().includes(search.toLowerCase()) ||
          partner.webSite?.toLowerCase().includes(search.toLowerCase()) ||
          partner.expertiseDescription
            ?.toLowerCase()
            .includes(search.toLowerCase()) ||
          partner.phoneNumber?.toLowerCase().includes(search.toLowerCase()) ||
          partner.email?.toLowerCase().includes(search.toLowerCase())
      );
    }
    //current page
    return partnerData.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    partners,
    currentPage,
    search,
    sorting,
    selectedFilter,
    ITEMS_PER_PAGE,
    updatedPartners,
  ]);

  const handleItemsPerPageChange = (itemsPerPage) => {
    setSelectedItemsPerPage(itemsPerPage);
    setCurrentPage(1);
  };

  const onSearch = (value) => {
    setSearch(value);
  };
  return (
    <div className="partners">
      <div className="container sm:mx-auto">
        <SearchBar onSearch={onSearch} />
      </div>
      <div className="flex justify-between px-9 my-6">
        <div>
          <div className="hs-dropdown relative inline-flex">
            <button
              id="hs-dropdown-default"
              type="button"
              className="hs-dropdown-toggle py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border font-medium bg-white text-gray-700 shadow-sm align-middle focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600 transition-all text-sm"
              style={{ width: "fit-content" }}
            >
              {selectedFilter ? UserType[selectedFilter] : "Select Filter"}
              <svg
                className="hs-dropdown-open:rotate-180 w-2.5 h-2.5 text-gray-600"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 5L8.16086 10.6869C8.35239 10.8637 8.64761 10.8637 8.83914 10.6869L15 5"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </button>

            <ul
              className="hs-dropdown-menu transition-[opacity,margin] duration-[0.1ms] hs-dropdown-open:opacity-100 opacity-0 w-72 hidden z-10 mt-2 min-w-[15rem] bg-white shadow-md rounded-lg p-2"
              aria-labelledby="hs-dropdown-default"
            >
              <li
                className={`flex hover:no-underline hover:text-[#222] items-center gap-x-3.5 py-2 px-3 rounded-md text-sm text-gray-800 hover:bg-gray-100 focus:ring-2 focus:ring-blue-500 dark:hover:bg-gray-700 ${
                  selectedFilter === "GHG" ? "font-bold" : ""
                } dark:hover:text-gray-300`}
                value={"GHG"}
                onClick={() => handleFilterChange("GHG")}
              >
                GHG account and marketing
              </li>

              <li
                className="flex hover:no-underline hover:text-[#222] items-center gap-x-3.5 py-2 px-3 rounded-md text-sm text-gray-800 hover:bg-gray-100 focus:ring-2 focus:ring-blue-500 dark:hover:bg-gray-700 dark:hover:text-gray-300"
                value={"CMAP"}
                onClick={() => handleFilterChange("CMAP")}
              >
                Carbon Market Access Provider
              </li>
              <li
                className="flex hover:no-underline hover:text-[#222] items-center gap-x-3.5 py-2 px-3 rounded-md text-sm text-gray-800 hover:bg-gray-100 focus:ring-2 focus:ring-blue-500 dark:hover:bg-gray-700 dark:hover:text-gray-300"
                value={"VAP"}
                onClick={() => handleFilterChange("VAP")}
              >
                Verification Assurance Provider
              </li>
              <li
                className="flex hover:no-underline hover:text-[#222] items-center gap-x-3.5 py-2 px-3 rounded-md text-sm text-gray-800 hover:bg-gray-100 focus:ring-2 focus:ring-blue-500 dark:hover:bg-gray-700 dark:hover:text-gray-300"
                value={"OTHER"}
                onClick={() => handleFilterChange("OTHER")}
              >
                Other
              </li>
              <li
                className="flex hover:no-underline hover:text-[#222] items-center gap-x-3.5 py-2 px-3 rounded-md text-sm text-gray-800 hover:bg-gray-100 focus:ring-2 focus:ring-blue-500 dark:hover:bg-gray-700 dark:hover:text-gray-300"
                value={"OTHER"}
                onClick={() => handleFilterChange("ALL")}
              >
                All
              </li>
            </ul>
          </div>

          <PaginationComponent
            totalElements={totalItems}
            selectedItemsPerPage={selectedItemsPerPage}
            onItemsPerPageChange={handleItemsPerPageChange}
          />
        </div>
        <InvitationModal />
      </div>
      <div className="flex flex-col mx-9">
        <div className="-m-1.5 overflow-x-auto">
          <div className="p-1.5 min-w-full inline-block align-middle">
            <div className="border rounded-xl shadow-sm overflow-auto max-h-[56vh] dark:border-gray-700 dark:shadow-gray-900">
              <table className="min-w-full divide-y divide-gray-200">
                <TableHeader
                  headers={headers}
                  onSorting={(field, order) => setSorting({ field, order })}
                />
                <tbody className="divide-y divide-gray-200">
                  {dataToShow.map((partner, index) => {
                    if (
                      selectedFilter &&
                      partner.userType !== selectedFilter &&
                      selectedFilter !== "ALL"
                    ) {
                      return null;
                    }
                    return (
                      <tr key={index}>
                        <td className="px-6 py-4 break-words text-sm font-medium text-gray-800 dark:text-gray-200 h-12">
                          <img
                            className="object-left max-w-xs w-28 h-12 object-contain"
                            src={
                              partner.companyLogo
                                ? `data:image/png;base64,${partner.companyLogo}`
                                : process.env.PUBLIC_URL +
                                  "/assets/logos/logo1.svg"
                            }
                            alt="Company Logo"
                          />
                        </td>
                        <td className="px-6 py-4 break-words text-sm text-gray-800 dark:text-gray-200">
                          {partner.companyName}
                        </td>
                        <td className="px-6 py-4 break-words text-sm text-gray-800 dark:text-gray-200">
                          {partner.expertiseDescription}
                        </td>
                        <td className="px-6 py-4 break-words text-sm text-gray-800 dark:text-gray-200">
                          <a
                            className="text-coc-blue hover:text-coc-blue"
                            href={partner.webSite}
                          >
                            {partner.webSite}
                          </a>
                        </td>
                        <td className="px-6 py-4 break-words text-sm text-gray-800 dark:text-gray-200">
                          {partner.email}
                        </td>
                        <td className="px-6 py-4 break-words text-sm text-gray-800 dark:text-gray-200">
                          {" "}
                          {partner.phoneNumber}
                        </td>
                        <td className="px-6 py-4 break-words text-sm text-gray-800 dark:text-gray-200 hidden">
                          {partner.userType}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
